import { useQuery } from "@apollo/client";

import { MEMBER_PROFILE } from "../queries/profile";
import {
  COUNT_MY_TRADES,
  GET_MY_TRADES,
  GET_SYMBOL_TIMERS,
} from "../queries/trade";
import { showErrorToast } from "../../components/apps/AppError";
import { Timer } from "../../types/models/AssetSymbol";
import { GET_TRANSACTION_RECORD } from "../queries/transaction";
import { Transaction } from "../../types/models/Transaction";

export const useQueryProfile = (callback?: any) => {
  const { loading, data, error, refetch } = useQuery(MEMBER_PROFILE, {
    fetchPolicy: "network-only",
    onError: (error) => showErrorToast(error.message),
    onCompleted: (data) => {
      if (callback) callback(data);
    },
  });

  const myProfile = data?.myProfile;

  return { loading, myProfile, error, refetch };
};

export const useQueryMyTrades = (status: string) => {
  const {
    loading,
    data: { myTradeList } = {},
    refetch,
  } = useQuery(GET_MY_TRADES, {
    variables: { status },
    fetchPolicy: "network-only",
    onError: (error) => showErrorToast(error.message),
  });

  return { loading, myTradeList, refetch };
};

export const useQueryCountMyTrades = () => {
  const {
    loading,
    data: { countMyTrades } = {},
    refetch,
  } = useQuery(COUNT_MY_TRADES, {
    onError: (error) => showErrorToast(error.message),
  });

  return { loading, countMyTrades, refetch };
};

export const useQueryTimers = () => {
  const { loading, data, refetch } = useQuery(GET_SYMBOL_TIMERS, {
    fetchPolicy: "cache-first",
    onError: (error) => showErrorToast(error.message),
  });

  const timers: Timer[] = data?.symbolTimers ?? [];

  return { loading, timers, refetch };
};

export const useQueryTransactions = (action?: string) => {
  const { loading, data, refetch } = useQuery(GET_TRANSACTION_RECORD, {
    variables: { action },
    fetchPolicy: "cache-and-network",
    onError: (error) => showErrorToast(error.message),
  });

  const transactions: Transaction[] = data?.myTransaction ?? [];

  return { loading, transactions, refetch };
};
